import React from 'react';
import useSearchParams from '../../../useSearchParams';
import {DatePicker} from 'components/antd';
import moment from 'moment';

interface Props {
  filter: string;
  value: {startDate: string; endDate: string};
}

const CustomizeItemDateFilter = ({filter, value}: Props) => {
  const {setQuery} = useSearchParams();
  const {RangePicker} = DatePicker;
  const format = 'YYYY-MM-DD';

  return (
    <RangePicker
      format={format}
      placeholder={['開始日', '終了日']}
      value={
        value?.startDate && value?.endDate
          ? [moment(value.startDate, format), moment(value.endDate, format)]
          : null
      }
      onChange={(value) => {
        if (value) {
          setQuery({
            [filter]: {
              startDate: value[0].format(format),
              endDate: value[1].format(format),
            },
          });
        } else {
          setQuery({
            [filter]: null,
          });
        }
      }}
    />
  );
};

export default CustomizeItemDateFilter;
